<template>
    <div id="home-student">
        <v-overlay absolute="" opacity="0.2" :value="loader">
            <v-progress-circular :color="kingsGreen" indeterminate size="32"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar.status" top :color="snackbar.color" :timeout="snackbar.timeout">
            <v-icon class="mr-1">{{ snackbar.icon }}</v-icon> {{ snackbar.message }}
        </v-snackbar>
        <v-container>
            <v-row>
                <v-col cols="12" md="8">
                    <welcome :announcements="announcements" :residenceTermsAppliedTo="residenceTermsAppliedTo">
                    </welcome>
                </v-col>
                <v-col cols="12" md="4">
                    <resources :releaseOfInformationForm="releaseOfInformationForm"></resources>
                    <contact></contact>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Contact from '../../components/Student/Home/Contact';
import Resources from '../../components/Student/Home/Resources';
import Welcome from '../../components/Student/Home/Welcome';

export default {
    name: 'home',
    components: {
        Contact,
        Resources,
        Welcome
    },
    data() {
        return {
            announcements: [],
            loader: true,
            snackbar: {
                color: 'success',
                icon: '',
                message: '',
                status: false,
                timeout: 5000
            },
            refreshTimer: '',
            releaseOfInformationForm: true,
            residenceTermsAppliedTo: []
        }
    },
    methods: {
        getHomeData() {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getHome`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to view this resource. Please refresh your application.`, true);
                    } else if (!json.result.match(/OK/i)) {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `Home dashboard data could not be retrieved. Please contact your system administrator.`, true);
                    }

                    // Announcements
                    that.announcements = json.announcements ? json.announcements : that.announcements;

                    // Residence Terms Applications
                    that.residenceTermsAppliedTo = json.residenceTermsAppliedTo ? json.residenceTermsAppliedTo : that.residenceTermsAppliedTo;

                    // Release of Information 
                    if (!json.roiExists || json.roiExists.exists != "1") {
                        that.releaseOfInformationForm = false;
                    }
                    
                    that.setLoader(false);
                })
                .catch(function () {
                    that.setLoader(false);
                })
        },
        refreshData() {
            this.getHomeData();
        },
        setLoader(bool) {
            this.loader = bool;
        },
        setNotification(color, icon, message, status) {
            // Reset snackbar
            this.snackbar.status = false;

            // Set snackbar fields
            this.snackbar.color = color;
            this.snackbar.icon = icon;
            this.snackbar.message = message;
            this.snackbar.status = status;
        }
    },
    computed: {
        kingsGreen() {
            return '#004236';
        }
    },
    created() {
        this.refreshData();
        this.refreshTimer = setInterval(this.refreshData, 60000);
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.refreshTimer);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.refreshTimer);
    }
}
</script>